import './expandable-section.css';
export default {
  "dirRtl": "pf-v6-m-dir-rtl",
  "expandableSection": "pf-v6-c-expandable-section",
  "expandableSectionContent": "pf-v6-c-expandable-section__content",
  "expandableSectionToggleIcon": "pf-v6-c-expandable-section__toggle-icon",
  "modifiers": {
    "expanded": "pf-m-expanded",
    "expandTop": "pf-m-expand-top",
    "expandBottom": "pf-m-expand-bottom",
    "limitWidth": "pf-m-limit-width",
    "displayLg": "pf-m-display-lg",
    "indented": "pf-m-indented",
    "truncate": "pf-m-truncate"
  }
};